module.exports = __webpack_public_path__ + "static/img/5-1.169ef29c.png";